import React from "react";
import { useSite } from "../../context/SiteContext";
const About = () => {
  const { profile } = useSite();
  return (
    <section
      id="about"
      className="relative bg-[#0a0a0a] py-24 md:py-36 border-t border-zinc-900"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid md:grid-cols-12 gap-10 md:gap-16">
          <div className="md:col-span-4">
            <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-amber-300/90 mb-6">
              01 — Profile
            </p>
            <h2 className="font-display text-4xl md:text-6xl leading-[1.02] text-stone-50">
              A producer who <span className="italic">builds systems</span>, not just shows.
            </h2>
          </div>

          <div className="md:col-span-7 md:col-start-6 space-y-6 text-stone-300 text-[17px] md:text-lg leading-[1.7]">
            {profile.longBio.map((p, i) => (
              <p key={i}>{p}</p>
            ))}

            <div className="pt-4 grid grid-cols-2 md:grid-cols-4 gap-6 border-t border-zinc-900 mt-10">
              {profile.stats.map((s) => (
                <div key={s.label} className="pt-8">
                  <div className="font-display text-3xl md:text-4xl text-stone-50">
                    {s.value}
                  </div>
                  <div className="mt-2 text-[11px] uppercase tracking-[0.22em] text-stone-500">
                    {s.label}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
